
export const  ON_COUNTRY_ITEM_TAP = "ON_COUNTRY_ITEM_TAP";
export const GET_ALL_CONTRIES= 'GET_ALL_CONTRIES';
export const GET_COUNTRY= 'GET_COUNTRY';
export const LOAD_COUNTRIES_LOADING= 'LOAD_COUNTRIES_LOADING';
export const LOAD_COUNTRY_ERROR= 'LOAD_COUNTRY_ERROR';

